import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import { languages } from "./languages";
import { ownLocaleUrl } from "./locales";

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        backend: {
            // A function rather than a template, because the URL is not
            // derivable from the tag: the build content-hashes each locale
            // file and the registry holds the resulting name. That hash is
            // what makes a translation change a cache miss. A level of the
            // fallback chain with no file of its own gets no URL, so i18next
            // falls through to the next level instead of being handed a
            // stand-in that shadows it.
            loadPath: (lngs) => ownLocaleUrl(lngs[0]),
        },
        debug: false,
        fallbackLng: "en",
        whitelist: Object.keys(languages),
        react: {
            bindI18n: "languageChanged loaded",
        }
    });

export { i18n };
